// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b70c3f13","551":"e22a79b0","640":"455a4867","869":"09cf33b8"}[chunkId] + ".chunk.js";
};